import React from "react";
import RequredStar from "./RequredStar";

const Textarea = ({ field }) => {
    return (
        <div className="jlt-w-full jlt-py-2">
            <label htmlFor={field.attributes.name} className="jlt-block jlt-text-base jlt-text-[#3F475A] jlt-font-normal">
                {field.settings.label} <RequredStar field={field} />
            </label>
            <textarea
                required={field.settings.validation_rules?.required?.value}
                rows={field.attributes.rows}
                cols={field.attributes.cols}
                type={field.attributes.type}
                id={field.attributes.name}
                name={field.attributes.name}
                placeholder={field.attributes.placeholder}
                defaultValue={field.attributes.value}
                className="jlt-w-full jlt-bg-[#FCFDFF] jlt-border-[1px] jlt-border-[#EBEEF5] jlt-rounded-[2px] jlt-mt-2 jlt-px-5 jlt-py-3 jlt-outline-none jlt-text-base jlt-text-[#3F475A] jlt-font-normal"></textarea>
        </div>
    );
};

export default Textarea;
